module.exports = __webpack_public_path__ + "img/form_accident.45dfdfbf.svg";